<div class="modal-overlay">
  <div class="modal-container">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">{{ isEditMode ? 'Edit User Segment' : 'Add User Segment' }}</h2>
        <button class="close-button" (click)="onClose()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="modal-body" (scroll)="onModalBodyScroll()">
      <!-- Segment Details Section -->
      <div class="section">
        <h3 class="section-title">SEGMENT DETAILS</h3>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Segment Name<span class="required">*</span></label>
            <input
              type="text"
              class="form-input"
              [(ngModel)]="segmentForm.name"
              placeholder="e.g. SUMMER25"
              maxlength="100"
              (blur)="onNameBlur()"
            />
            <div *ngIf="shouldShowNameError()" class="error-message">
              <span *ngIf="segmentForm.name.trim() === ''">Segment name is required</span>
              <span *ngIf="segmentForm.name.trim() !== '' && segmentForm.name.trim().length < 2"
                >Segment name must be at least 2 characters long</span
              >
              <span *ngIf="segmentForm.name.trim() !== '' && segmentForm.name.trim().length > 100"
                >Segment name must not exceed 100 characters</span
              >
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Description<span class="required">*</span></label>
            <textarea
              class="form-textarea"
              [(ngModel)]="segmentForm.description"
              placeholder="Type your description here"
              rows="3"
              maxlength="250"
              (blur)="onDescriptionBlur()"
            ></textarea>
            <div *ngIf="shouldShowDescriptionError()" class="error-message">
              <span *ngIf="segmentForm.description.trim() === ''">Description is required</span>
              <span
                *ngIf="
                  segmentForm.description.trim() !== '' && segmentForm.description.trim().length < 2
                "
                >Description must be at least 2 characters long</span
              >
              <span
                *ngIf="
                  segmentForm.description.trim() !== '' &&
                  segmentForm.description.trim().length > 250
                "
                >Description must not exceed 250 characters</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Create method (create only) -->
      <div class="section" *ngIf="!isEditMode">
        <h3 class="section-title">CREATE SEGMENT VIA</h3>
        <div class="create-method-toggle" role="tablist" aria-label="Create segment method">
          <button
            type="button"
            class="method-btn"
            role="tab"
            [attr.aria-selected]="createMethod === 'rule'"
            [class.active]="createMethod === 'rule'"
            (click)="onCreateMethodChange('rule')"
          >
            Segment rule
          </button>
          <button
            type="button"
            class="method-btn"
            role="tab"
            [attr.aria-selected]="createMethod === 'upload'"
            [class.active]="createMethod === 'upload'"
            (click)="onCreateMethodChange('upload')"
          >
            Upload Excel
          </button>
        </div>
      </div>

      <div class="section upload-section" *ngIf="isEditMode && createMethod === 'upload'">
        <h3 class="section-title">UPLOAD EXCEL</h3>
        <p class="upload-edit-note">
          This segment was created from an Excel or CSV file. Members stay as uploaded. You can
          change the name and description here.
        </p>
      </div>

      <!-- Segment Rule Section -->
      <div class="section" *ngIf="createMethod === 'rule'">
        <h3 class="section-title">SEGMENT RULE</h3>

        <div class="criteria-wrapper">
          <div *ngFor="let criteria of segmentForm.criteria; let i = index; trackBy: trackByIndex">
            <div class="criteria-container">
              <div class="criteria-header">
                <span class="criteria-label"
                  >Criteria {{ i + 1 }}<span class="required">*</span></span
                >
              </div>

              <div class="criteria-form">
                <div class="criteria-row">
                  <div class="form-group">
                    <label class="form-label">Criteria Type<span class="required">*</span></label>
                    <div class="select-wrapper">
                      <mat-select
                        class="form-select criteria-dropdown"
                        [(ngModel)]="criteria.type"
                        (selectionChange)="onCriteriaTypeChange(i, $event.value)"
                        (openedChange)="
                          onCriteriaSelectOpenedChange(
                            $event,
                            'criteria-type-' + i,
                            criteriaTypeSelect
                          )
                        "
                        placeholder="Select an option"
                        panelClass="segment-criteria-select-panel"
                        #criteriaTypeSelect
                      >
                        <mat-option
                          *ngFor="let option of criteriaTypes; trackBy: trackByValue"
                          [value]="option.value"
                        >
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Conditions<span class="required">*</span></label>
                    <div class="select-wrapper">
                      <mat-select
                        class="form-select"
                        [(ngModel)]="criteria.condition"
                        (selectionChange)="onConditionChange(i, $event.value)"
                        (openedChange)="
                          onCriteriaSelectOpenedChange($event, 'condition-' + i, conditionSelect)
                        "
                        [disabled]="!criteria.type"
                        placeholder="Select an option"
                        panelClass="segment-criteria-select-panel"
                        #conditionSelect
                      >
                        <mat-option
                          *ngFor="
                            let option of getConditionsForCriteria(criteria.type);
                            trackBy: trackByValue
                          "
                          [value]="option.value"
                        >
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </div>
                </div>

                <!-- Dynamic value input based on value_type -->
                <div class="value-input-container">
                  <!-- Text input for Text value type -->
                  <div
                    class="form-group"
                    *ngIf="getValueTypeForCondition(criteria.type, criteria.condition) === 'Text'"
                  >
                    <label class="form-label">Value<span class="required">*</span></label>
                    <input
                      type="text"
                      [(ngModel)]="criteria.value"
                      name="value_{{ i }}"
                      id="value_{{ i }}"
                      placeholder="Enter value"
                      class="form-control"
                    />
                  </div>

                  <!-- Date input for date value type -->
                  <div
                    class="form-group"
                    *ngIf="getValueTypeForCondition(criteria.type, criteria.condition) === 'date'"
                  >
                    <label class="form-label">Date<span class="required">*</span></label>
                    <mat-form-field appearance="outline" class="form-control2">
                      <input
                        matInput
                        [matDatepicker]="valuePicker"
                        [(ngModel)]="criteria.value"
                        name="value_{{ i }}"
                        id="value_{{ i }}"
                        (blur)="onCriteriaBlur(i, 'value')"
                        placeholder="Select date"
                      />
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="valuePicker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #valuePicker></mat-datepicker>
                    </mat-form-field>
                    <div
                      *ngIf="shouldShowDateError(i, 'value', criteria.value)"
                      class="error-message"
                    >
                      Please enter a valid date
                    </div>
                  </div>

                  <!-- Number input for days value type -->
                  <div
                    class="form-group"
                    *ngIf="getValueTypeForCondition(criteria.type, criteria.condition) === 'days'"
                  >
                    <label class="form-label">Number of Days<span class="required">*</span></label>
                    <input
                      type="number"
                      [(ngModel)]="criteria.value"
                      name="value_{{ i }}"
                      id="value_{{ i }}"
                      placeholder="Enter number of days"
                      min="1"
                      class="form-control"
                    />
                  </div>

                  <!-- Date range inputs for date_range value type -->
                  <div
                    class="date-parent"
                    *ngIf="
                      getValueTypeForCondition(criteria.type, criteria.condition) === 'date_range'
                    "
                  >
                    <div class="form-group">
                      <label class="form-label">Start Date<span class="required">*</span></label>
                      <mat-form-field appearance="outline" class="form-control2">
                        <input
                          matInput
                          [matDatepicker]="startDatePicker"
                          [(ngModel)]="criteria.startDate"
                          name="startDate_{{ i }}"
                          id="startDate_{{ i }}"
                          (blur)="onCriteriaBlur(i, 'startDate')"
                          placeholder="Select start date"
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="startDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                      </mat-form-field>
                      <div
                        *ngIf="shouldShowDateError(i, 'startDate', criteria.startDate)"
                        class="error-message"
                      >
                        Please enter a valid start date
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="form-label">End Date<span class="required">*</span></label>
                      <mat-form-field appearance="outline" class="form-control2">
                        <input
                          matInput
                          [matDatepicker]="endDatePicker"
                          [(ngModel)]="criteria.endDate"
                          name="endDate_{{ i }}"
                          id="endDate_{{ i }}"
                          (blur)="onCriteriaBlur(i, 'endDate')"
                          placeholder="Select end date"
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="endDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                      </mat-form-field>
                      <div
                        *ngIf="shouldShowDateError(i, 'endDate', criteria.endDate)"
                        class="error-message"
                      >
                        Please enter a valid end date
                      </div>
                      <div
                        *ngIf="shouldShowDateRangeError(i, criteria.startDate, criteria.endDate)"
                        class="error-message"
                      >
                        Start date must be before end date
                      </div>
                    </div>
                  </div>

                  <!-- Package selection for package value type -->
                  <div
                    class="form-group"
                    *ngIf="
                      getValueTypeForCondition(criteria.type, criteria.condition) === 'package'
                    "
                  >
                    <label class="form-label">Select Packages<span class="required">*</span></label>
                    <div class="checkbox-group">
                      <div
                        *ngFor="let package of packageOptions; trackBy: trackByValue"
                        class="checkbox-item"
                      >
                        <mat-checkbox
                          [checked]="criteria.selectedPackages.includes(package.value)"
                          (change)="onPackageSelectionChange(i, package.value, $event)"
                          [id]="'package_' + i + '_' + package.value"
                        >
                        </mat-checkbox>
                        <label [for]="'package_' + i + '_' + package.value">{{
                          package.label
                        }}</label>
                      </div>
                    </div>
                  </div>

                  <!-- Car wash type selection for car_wash_type value type -->
                  <div
                    class="form-group"
                    *ngIf="
                      getValueTypeForCondition(criteria.type, criteria.condition) ===
                      'car_wash_type'
                    "
                  >
                    <label class="form-label"
                      >Select Car Wash Types<span class="required">*</span></label
                    >
                    <div class="checkbox-group">
                      <div
                        *ngFor="let washType of carWashTypeOptions; trackBy: trackByValue"
                        class="checkbox-item"
                      >
                        <mat-checkbox
                          [checked]="criteria.selectedWashTypes.includes(washType.value)"
                          (change)="onWashTypeSelectionChange(i, washType.value, $event)"
                          [id]="'washType_' + i + '_' + washType.value"
                        >
                        </mat-checkbox>
                        <label [for]="'washType_' + i + '_' + washType.value">{{
                          washType.label
                        }}</label>
                      </div>
                    </div>
                  </div>

                  <!-- Vehicle make selection for vehicle_make value type -->
                  <div
                    class="form-group"
                    *ngIf="
                      getValueTypeForCondition(criteria.type, criteria.condition) === 'vehicle_make'
                    "
                  >
                    <label class="form-label"
                      >Select Vehicle Makes<span class="required">*</span></label
                    >

                    <!-- Search Box -->
                    <div class="vehicle-search-container">
                      <div class="search-input-wrapper">
                        <svg
                          class="search-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 14L11.1 11.1"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          class="vehicle-search-input"
                          placeholder="Search make"
                          [(ngModel)]="vehicleMakeSearchTerm"
                          (ngModelChange)="onVehicleMakeSearchChange()"
                        />
                        <svg
                          *ngIf="vehicleMakeSearchTerm"
                          class="close-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          (click)="onClearVehicleMakeSearch()"
                        >
                          <path
                            d="M12 4L4 12M4 4L12 12"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <!-- No Results Error Message -->
                      <div *ngIf="hasNoVehicleMakeResults()" class="search-error-message">
                        <span
                          >No results found for
                          <span class="search-term">"{{ vehicleMakeSearchTerm }}"</span></span
                        >
                        <a class="clear-search-link" (click)="onClearVehicleMakeSearch()"
                          >Clear search</a
                        >
                      </div>
                    </div>

                    <!-- Vehicle Makes Grid -->
                    <div class="vehicle-makes-grid" *ngIf="!hasNoVehicleMakeResults()">
                      <div
                        *ngFor="
                          let vehicleMake of getPaginatedVehicleMakes(i);
                          trackBy: trackByIndex
                        "
                        class="vehicle-make-item"
                      >
                        <mat-checkbox
                          [checked]="criteria.selectedVehicleMakes.includes(vehicleMake.value)"
                          (change)="onVehicleMakeSelectionChange(i, vehicleMake.value, $event)"
                          [id]="'vehicleMake_' + i + '_' + vehicleMake.value"
                        >
                        </mat-checkbox>
                        <label [for]="'vehicleMake_' + i + '_' + vehicleMake.value">{{
                          vehicleMake.label
                        }}</label>
                      </div>
                    </div>

                    <!-- Show More Button -->
                    <div
                      class="show-more-container"
                      *ngIf="
                        !hasNoVehicleMakeResults() &&
                        !vehicleMakeShowAll &&
                        getRemainingVehicleMakeCount(i) > 0
                      "
                    >
                      <button type="button" class="show-more-btn" (click)="showAllVehicleMakes()">
                        +{{ getRemainingVehicleMakeCount(i) }} more
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Logical Operators -->
            <div
              class="logical-operators"
              *ngIf="segmentForm.criteria.length > 1 && i !== segmentForm.criteria.length - 1"
            >
              <div class="operator-buttons">
                <button
                  class="operator-btn"
                  [class.active]="segmentForm.logicalOperators[i] === 'AND'"
                  (click)="onLogicalOperatorChange(i, 'AND')"
                >
                  AND
                </button>
                <button
                  class="operator-btn"
                  [class.active]="segmentForm.logicalOperators[i] === 'OR'"
                  (click)="onLogicalOperatorChange(i, 'OR')"
                >
                  OR
                </button>
              </div>
            </div>
          </div>
        </div>

        <button class="add-criteria-btn" (click)="onAddCriteria()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8 3.33V12.67M3.33 8H12.67"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Add Criteria</span>
        </button>
      </div>

      <!-- Upload Excel Section -->
      <div class="section upload-section" *ngIf="!isEditMode && createMethod === 'upload'">
        <div class="upload-meta-row" *ngIf="platformHintLabel">
          <span class="platform-hint"> {{ platformHintLabel }} · platform already selected. </span>
        </div>

        <input
          #excelFileInput
          type="file"
          class="file-input-hidden"
          accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
          (change)="onExcelFileSelected($event)"
        />

        <div
          class="upload-dropzone"
          [class.has-file]="!!selectedExcelFile"
          [class.drag-over]="isDragOver"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="excelFileInput.click()"
        >
          <ng-container *ngIf="!selectedExcelFile; else selectedFileBlock">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 16V4M12 4L8 8M12 4L16 8"
                stroke="#555963"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 16V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V16"
                stroke="#555963"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
            <p class="dropzone-title">
              Drop your file here or <span class="choose-link">choose file</span>
            </p>
            <p class="dropzone-sub">.xlsx or .csv</p>
          </ng-container>
          <ng-template #selectedFileBlock>
            <div class="selected-file" (click)="$event.stopPropagation()">
              <div class="selected-file-info">
                <span class="file-name">{{ selectedExcelFile?.name }}</span>
                <span class="file-size">{{ formatFileSize(selectedExcelFile?.size || 0) }}</span>
              </div>
              <button type="button" class="remove-file-btn" (click)="clearSelectedExcelFile()">
                Remove
              </button>
            </div>
          </ng-template>
        </div>

        <div *ngIf="excelFileError" class="error-message upload-error">{{ excelFileError }}</div>

        <p class="sample-file-row">
          No file handy?
          <button type="button" class="sample-link" (click)="downloadSampleFile()">
            Try with a sample file (3 rows)
          </button>
        </p>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-left">
        <button class="btn btn-tertiary btn-medium" [disabled]="!hasFormData" (click)="onClear()">
          Clear
        </button>
      </div>
      <div class="footer-right">
        <button class="btn btn-secondary btn-medium" (click)="onClose()">Cancel</button>
        <button
          class="btn btn-primary btn-medium"
          [ngClass]="{
            disabled: !isFormValidState || isLoading || (isEditMode && !hasFormChanges),
          }"
          [disabled]="!isFormValidState || isLoading || (isEditMode && !hasFormChanges)"
          (click)="onSave()"
        >
          <span *ngIf="isLoading">Creating...</span>
          <span *ngIf="!isLoading"> {{ isEditMode ? 'Save Changes' : 'Add Segment' }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
